<div>
  <ng-container *ngIf="content.length > limit; else underLimit">
    {{ content }}
    <span class="readMore" *ngIf="!isContentToggled" (click)="toggleContent()"
      >Read More</span
    >
    <span class="readLess" *ngIf="isContentToggled" (click)="toggleContent()"
      >Read Less</span
    >
  </ng-container>
  <ng-template #underLimit> {{ content }}</ng-template>
</div>

 
